import { Component, h, Host, Prop, Watch } from '@stencil/core'
import { State } from '@stencil/core/internal';
import { trans } from '~/store'

@Component({
    tag: 'zr-modal',
    styleUrl: 'zr-modal.scss',
    shadow: true,
})

/**
 * The confirmation modal.
 */
export class ZrModal {
    /**
     * Ref for dialog.
     */
    dialogRef: HTMLDialogElement

    /**
     *  Text Heading.
     */
    @Prop() heading = ''

    /**
     * State if open.
     */
    @State() modalOpen = false

    /**
     * Aria Label for Close Button.
     */
    ariaLabelClose = null

    /**
     * Label for closing tag.
     */
    closingLinkLabel = null

    /**
     * Listen on popup open/close and Limit Body for Fullscreen Overlay.
     */
    @Watch('modalOpen')
    limitBodyHeight() {
        if (this.modalOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.removeProperty('overflow');
        }
    }

    /**
     * Handle Btn click.
     */
    handleDialogVisibility = (open: boolean) => {
        if(open){
            this.dialogRef.showModal()
            this.modalOpen = true
        }else{
            this.dialogRef.close()
            this.modalOpen = false
        }
    }

    /**
     * Component event.
     */
    componentDidRender(){
        /**
         * Handle outside click.
         */
        const handleOutsideClick = (e:any) => {
            e.stopPropagation();
            if(e.target === this.dialogRef) {
                this.dialogRef.close()
                this.modalOpen = false
            }
        }
        this.dialogRef.addEventListener('click', handleOutsideClick)

        return(
            () => {
                this.dialogRef.removeEventListener('click', handleOutsideClick)
            }
        )
    }

    /**
     * Component event.
     */
    componentWillRender() {
        if (!this.ariaLabelClose) {
            this.closingLinkLabel = this.ariaLabelClose = trans(
                'frontend/plugins/RdssUi.close',
                'Schließen'
            )
        }
    }

    /**
     * Renders the component.
     */
    render() {
        return (
            <Host>
                <dialog
                    class="zr-modal"
                    ref={(el) => {
                        this.dialogRef = el as HTMLDialogElement
                    }}
                    onClose={() => this.handleDialogVisibility(false)}
                >
                    <div class="zr-modal__inner">
                        <button
                            class='zr-modal__close'
                            aria-label={this.ariaLabelClose}
                            onClick={() => this.handleDialogVisibility(false)}
                        >{this.ariaLabelClose}</button>
                        {(this.heading !== '') && (<h2>{this.heading}</h2>)}
                        <div class="zr-modal-content__wrapper">
                            <slot name="zr-modal-content"/>
                            <a class="zr-modal-closing__tag"
                                aria-label={this.ariaLabelClose}
                                onClick={() => this.handleDialogVisibility(false)}
                            >
                                {this.closingLinkLabel}
                            </a>
                        </div>
                    </div>
                </dialog>
                <div class="zr-modal__slot"
                    onClick={() => this.handleDialogVisibility(true)}
                >
                    <slot name="zr-modal-trigger"/>
                </div>
            </Host>
        )
    }
}
